import { render, staticRenderFns } from "./story.vue?vue&type=template&id=1b287d73&"
import script from "./story.vue?vue&type=script&lang=js&"
export * from "./story.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports